<template>
    <div v-if="isShow">
        "别急！程序猿们正在努力的开发！"
        <Button type="success" long @click="login">更换登录类型</Button>
    </div>
</template>
<style>
</style>
<script>
import axios from 'axios';
export default {
    name : "webmaster",
    mounted : function(){
        this.$store.registerModule(['system','webmaster'],{
            state : {
                $ : this
            }
        });
    },
    data : function(){
        return {
            isShow :false
        }
    },
    methods : {
        show : function(isShow){
            this.isShow = isShow ? true : false;
            this.$store.state.system.$.upData();
        },
        login : function(){
            this.$store.state.system.$.toLogin();
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/webmaster.vue